import { IsPhoneNumber, Length, MinLength } from "class-validator";

export class WaitlistUserDto {
	public id: string;
	public phone: string;
	public fullName: string;
	public number: number;
	public userId: string;
	public createdAt: Date;
	public updatedAt: Date;
}

export class UpdateWaitlistUserDto {
	public fullName: string;
}

export class JoinWaitlistWithPhoneDto {
	@MinLength(3)
	@IsPhoneNumber()
	phone: string;
}

export class JoinWaitlistWithPhoneVerificationDto {
	@MinLength(3)
	@IsPhoneNumber()
	phone: string;

	@Length(6, 6)
	code: string;
}
